<template>
  <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
    <multiselect ref="multiSelect" v-model="selected" :custom-label="getLabel" track-by="_id" :placeholder="placeHolder"
                 :options="items" :multiple="multiple"
                 @input="onInput" @search-change="search">
      <template v-slot:noResult>
        {{ $t('notFoundSearch') }}
      </template>
      <template v-slot:noOptions>
        {{ $t('notFoundSearch') }}
      </template>
    </multiselect>
  </b-form-group>
</template>

<script>
import _ from 'lodash'
import list from '@/mixins/List'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  props: {
    model: Object,
    status: {
      type: Number,
      default: 0
    },
    roleFilter: {
      type: String,
      default: null
    },
    departmentFilter: {
      type: String,
      default: null
    },
    groupFilter: {
      type: String,
      default: null
    },
    attribute: {
      type: String,
      default: 'user'
    },
    label: String,
    errors: Array,
    placeHolder: {
      type: String,
      default: 'Select admin user'
    },
    multiple: Boolean,
    filterByGroup: {
      type: Boolean,
      default: false
    },
    filterByDepartment: {
      type: Boolean,
      default: false
    },
    notUpdatedSelect: {
      type: Boolean,
      default: false
    }
  },
  components: { Multiselect },
  mixins: [list],
  data() {
    return {
      selected: null,
      state: null,
      errorTxt: '',
      options: [],
      showList: false,
      service: 'admin-user',
      autoLoad: false,
      afterLoad: function() {
        if (this.notUpdatedSelect) {
          this.items.push({ _id: 'notUpdated', name: this.$t('notUpdated') })
        }
      },
      defaultFilterFormModel: {
        keyword: '',
        status: this.status,
        role: this.roleFilter,
        department: this.departmentFilter,
        group: this.groupFilter
      },
      focused: false,
      changeTrigger: true
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null
        this.errorTxt = ''
        if (this.filterByGroup && val.group !== this.group) {
          this.filterFormModel.group = val.group
          this.group = val.group
          this.selected = null
          this.load()
        }
        if (this.filterByDepartment && val.department !== this.department) {
          this.filterFormModel.department = val.department
          this.department = val.department
          this.selected = null
          this.load()
        }
        if (val[this.attribute] != null) {
          if (this.changeTrigger) {
            this.loadSelected()
          }
          this.changeTrigger = true
        } else {
          this.selected = null
        }
      }, deep: true
    },
    selected(val) {
      this.changeTrigger = false
      if (val === null) {
        this.model[this.attribute] = val
      } else if (this.multiple) {
        this.model[this.attribute] = val.map(s => s._id)
      } else {
        this.model[this.attribute] = val._id
      }
    },
    errors(val) {
      let hasErr = false
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false
            this.errorTxt = v.msg
            hasErr = true
          }
        })
      }
      this.state = !hasErr
    }
  },
  methods: {
    onInput() {
      let val = this.selected
      this.changeTrigger = false
      if (val === null) {
        this.model[this.attribute] = val
      } else if (this.multiple) {
        this.model[this.attribute] = val.map(s => s._id)
      } else {
        this.model[this.attribute] = val._id
      }
      this.$emit('change')
    },
    getLabel({ name }) {
      return `${name}`
    },
    search: _.debounce(function(event) {
      this.filterFormModel.keyword = event
      this.filterFormModel.page = 1
      this.load()
    }, 250),
    loadSelected() {
      if (this.model[this.attribute]) {
        let ids
        if (this.multiple) {
          ids = this.model[this.attribute].join(',')
        } else {
          ids = this.model[this.attribute]
        }
        if (ids) {
          this.$bgService.get(this.service, {
            params: { page: 1, pageSize: 100, ids: ids }
          }).then(response => {
            if (this.multiple) {
              this.selected = response.data.docs
            } else if (response.data.docs.length) {
              let rs = response.data.docs
              this.selected = rs.find(kq => kq._id === this.model[this.attribute])
            }
          })
        }
      }
    }
  },
  mounted() {
    this.selected = null
    this.loadSelected()
    const inputElement = this.$refs.multiSelect.$el.querySelector('input')
    if (inputElement) {
      inputElement.addEventListener('focus', this.load)
    }
  },
  beforeDestroy() {
    const inputElement = this.$refs.multiSelect.$el.querySelector('input')
    if (inputElement) {
      inputElement.removeEventListener('focus', this.load)
    }
  },
  i18n: {
    messages: {
      en: {
        selectAdminUser: 'Select Admin User'
      },
      vi: {
        selectAdminUser: 'Chọn tài khoản admin'
      }
    }
  }
}
</script>